import React, { Component, PropTypes } from 'react';

class Ellipsis extends Component {
  static propTypes = {
    color: PropTypes.string
  }

  static defaultProps = {
    color: '#9b9b9b'
  }

  render() {
    const { color } = this.props;

    return (
        <svg width="16px" height="16px" viewBox="0 0 20 10">
            <g id="Symbol" stroke={color} strokeWidth="1" fill={color} fillRule="evenodd">
                <g id="icon/more">
                    <g id="Group-4">
                        <ellipse id="Oval" cx="2" cy="8.85074627" rx="2" ry="1.85074627"></ellipse>
                        <ellipse id="Oval-Copy" cx="10" cy="8.85074627" rx="2" ry="1.85074627"></ellipse>
                        <ellipse id="Oval-Copy-2" cx="18" cy="8.85074627" rx="2" ry="1.85074627"></ellipse>
                    </g>
                </g>
            </g>
        </svg>
    );
  }
}

export default Ellipsis;



// WEBPACK FOOTER //
// ./app/components/icons/Ellipsis.js